/** @module csi/view/ToolbarPluginPushButton **/
define([
	"dojo/_base/declare",
	"dijit/form/ToggleButton",
	"csi/view/ToolbarPlugin"
], function(declare, ToggleButton, ToolbarPlugin) {
	
	return declare([ToggleButton, ToolbarPlugin], {
		"class": "csi-button-toggle csi-single-toggle",

		/**
		 * @override
		 * Ignore this event in favor of onChange
		 */
		onClick: function(e) {
			e.stopPropagation();
			return true;
		},
		
		/**
		 * Set appearance based on action
		 */
		postMixInProperties: function() {
			this._mixinActionProperties();
			this.inherited(arguments);
		},
		
		/**
		 * Do not instantiate when printing
		 */
		validatePlugin: function(ctx) {
			return !ctx.bPrint;
		}
   	});
});
	